import React from 'react';
import { ContentCard } from './ContentCard';

export const FetchErrorCard = () => (
  <ContentCard content="Une erreur est survenue pendant le chargement des données" data-testid="table-no-result" />
);
